import { FormattedMessage } from 'react-intl';

const Backlog = () => {
	return (
		<div>
			<p>
				<FormattedMessage
					id="JiraSoftwarePricingPageTeam24.features.backlogAndTimeline.content.body"
					defaultMessage="Choose from different views to support your way of working."
				/>
			</p>
		</div>
	);
};

export default Backlog;
